var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quote"},[_c('div',{staticClass:"start",domProps:{"innerHTML":_vm._s(_vm.svg_quote_start)}}),_c('p',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('div',{staticClass:"stop",domProps:{"innerHTML":_vm._s(_vm.svg_quote_stop)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }